module.exports = __webpack_public_path__ + "img/candidate-blue.cce9ba3b.png";